import { useState } from "react";
import "./styles.css";

import ModalSubNav from "../../../../Components/Modais";
import { IComponentModal } from "../../../../Components/Modais/IModalComponent";

import { CadastroTipos } from "./CadastroTipos";
import { EtapasCategorias } from "./EtapasCategorias";
import { ConfiguracoesTemplates } from "./ConfiguracoesTemplates";

export function SubNavGestaoDeCadastros() {
    const [show, SetShow] = useState(false);
    const [Modal, SetModal] = useState<IComponentModal>();

    return (
        <div className="menu-submenu">
            <div id="accordion">
                <CadastroTipos
                    SetShow={SetShow}
                    show={show}
                    Modal={Modal}
                    SetModal={SetModal}
                />
                <EtapasCategorias
                    SetShow={SetShow}
                    show={show}
                    Modal={Modal}
                    SetModal={SetModal}
                />
                <ConfiguracoesTemplates
                    SetShow={SetShow}
                    show={show}
                    Modal={Modal}
                    SetModal={SetModal}
                />
            </div>
            <ModalSubNav show={show} setShow={SetShow} ModalComponent={Modal} />
        </div>
    );
}
